import React from 'react';
import { Navigation } from '../components/landing/Navigation';
import { HeroSection } from '../components/landing/HeroSection';
import { WhatIsSection } from '../components/landing/WhatIsSection';
import { SubjectsGrid } from '../components/landing/SubjectsGrid';
import { HowItWorksSection } from '../components/landing/HowItWorksSection';
import { FeaturesGrid } from '../components/landing/FeaturesGrid';
import { PortalsSection } from '../components/landing/PortalsSection';
import { InvestorsSection } from '../components/landing/InvestorsSection';
import { ArchitectureSection } from '../components/landing/ArchitectureSection';
import { FAQSection } from '../components/landing/FAQSection';
import { FooterSection } from '../components/landing/FooterSection';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-orange-100 selection:text-orange-900" data-id="element-248">
      <Navigation data-id="element-249" />

      <main data-id="element-250">
        <HeroSection data-id="element-251" />
        <WhatIsSection data-id="element-252" />
        <SubjectsGrid data-id="element-253" />
        <HowItWorksSection data-id="element-254" />
        <FeaturesGrid data-id="element-255" />
        <PortalsSection data-id="element-256" />
        <InvestorsSection data-id="element-257" />
        <ArchitectureSection data-id="element-258" />
        <FAQSection data-id="element-259" />
      </main>

      <FooterSection data-id="element-260" />
    </div>;
}